// import axios from "axios";
// import React, { Component, useState, useEffect } from "react";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import "../css/admindash.css";
// import DataTable from "react-data-table-component";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   LineElement,
//   PointElement,
//   LinearScale,
//   Title,
//   CategoryScale,
// } from "chart.js";
// import CanvasJSReact from "@canvasjs/react-charts";
// import { FiUsers } from "react-icons/fi";
// import { ImUserTie } from "react-icons/im";
// import { AiOutlineSchedule } from "react-icons/ai";
// import { MdWork } from "react-icons/md";
// import { HiMiniUserGroup } from "react-icons/hi2";
// import { FaUserCheck, FaUserTie } from "react-icons/fa";
// import { FaChalkboardUser, FaUserXmark } from "react-icons/fa6";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment";
// import { SlCalender } from "react-icons/sl";
// import { ImSearch } from "react-icons/im";
// import Dropdown from "react-dropdown";
// import "react-dropdown/style.css";
// import { ClipLoader } from "react-spinners";

// ChartJS.register(LineElement, PointElement, LinearScale, Title, CategoryScale);
// var CanvasJS = CanvasJSReact.CanvasJS;
// var CanvasJSChart = CanvasJSReact.CanvasJSChart;

// const UserLineChart = () => {
//   const [userData, setUserData] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://raasbackend.vetrinahealthcare.com/student"
//         );
//         const data = response.data;

//         // Group the data by date and count the number of users
//         const groupedData = data.reduce((acc, curr) => {
//           const date = curr.created_at.split("T")[0];
//           if (acc[date]) {
//             acc[date].count += 1;
//           } else {
//             acc[date] = { date, count: 1 };
//           }
//           return acc;
//         }, {});

//         // Convert the grouped data to an array
//         const chartData = Object.values(groupedData);

//         setUserData(chartData);
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const chartData = {
//     labels: userData.map((data) => data.date),
//     datasets: [
//       {
//         label: "Number of Users",
//         data: userData.map((data) => data.count),
//         borderColor: "rgb(75, 192, 192)",
//         backgroundColor: "rgba(0, 0, 0, 0)",
//         borderWidth: 2,
//         pointBackgroundColor: "rgba(75, 192, 192, 1)",
//         pointBorderColor: "rgba(75, 192, 192, 1)",
//         pointHoverBackgroundColor: "rgba(75, 192, 192, 1)",
//         pointHoverBorderColor: "rgba(220,220,220,1)",
//         tension: 0.4, // Adjust tension for smoother curves
//       },
//     ],
//   };

//   return (
//     <div>
//       <Line
//         data={chartData}
//         options={{
//           responsive: true,
//           plugins: {
//             title: {
//               display: true,
//               text: "Number of Users Over Time",
//               font: {
//                 size: 25, // Increase font size for title
//               },
//             },
//             tooltip: {
//               mode: "index",
//               intersect: false,
//               backgroundColor: "rgba(0, 0, 0, 0.8)",
//               titleFont: { size: 16 },
//               bodyFont: { size: 14 },
//             },
//           },
//           scales: {
//             x: {
//               grid: {
//                 display: true,
//                 color: "rgba(0, 0, 0, 0.1)", // Adjust grid line color
//               },
//               ticks: {
//                 font: { size: 14 },
//               },
//             },
//             y: {
//               grid: {
//                 display: true,
//                 color: "rgba(0, 0, 0, 0.1)",
//               },
//               ticks: {
//                 font: { size: 14 },
//               },
//             },
//           },
//           animation: {
//             duration: 1500, // Adjust animation duration
//           },
//         }}
//       />
//     </div>
//   );
// };

// class HRDashboard extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       filterDate: "", // Initialize filter for date
//       filterName: "",
//       totalusers: 0,
//       activeUsersCount: 0,
//       inactiveUsersCount: 0,
//       totalApplicants: 0,
//       totalInterviews: 0,
//       totalJobOpenings: 0,
//       appliedCount: 0,
//       underReviewCount: 0,
//       interviewScheduledCount: 0,
//       selectedCount: 0,
//       rejectedCount: 0,
//       interviewercount: 0,
//       hrcount: 0,
//       candidatecount: 0,
//       admincount: 0,
//       monthlyUserCounts: [],
//       filterDate: "", // Initialize filter for date
//       filterName: "",
//       user_list: [],
//       applicant_list: [],
//       jobopening_list: [],
//       interview_scheduled_list: [],
//       Hr_list: [],
//       Interviewer_list: [],
//       date: [],
//       showDateInput: false,
//       showNameInput: false,
//       filterDate1: "", // Initialize filter for date
//       showDateInput1: false,
//       filterDate2: "", // Initialize filter for date
//       filterName2: "",
//       showDateInput2: false,
//       showNameInput2: false,
//       pageCount: 0, // Initialize page count
//       userCurrentPage: 1,
//       userItemsPerPage: 3,
//       interviewCurrentPage: 1,
//       interviewItemsPerPage: 3,
//       jobOpeningCurrentPage: 1,
//       jobOpeningItemsPerPage: 3,
//       startDate: null,
//       endDate: null,
//       startDate2: null,
//       endDate2: null,
//       Personality_score: [],
//     };
//     this.traitOptions = [
//       { value: "neuroticism", label: "Neuroticism" },
//       { value: "conscientiousness", label: "Conscientiousness" },
//       { value: "openness", label: "Openness" },
//       { value: "extraversion", label: "Extraversion" },
//       { value: "agreeableness", label: "Agreeableness" },
//     ];
//     this.selectedTrait = "";
//   }
//   componentDidMount() {
//     this.fetchTotalApplicants();
//     this.fetchTotalInterviews();
//     this.fetchTotalJobOpenings();
//     this.fetchJobApplicationStatusCounts();
//     this.fetchTotalUsers();
//     this.fetchTotalAccountStatus();
//     this.fetchrolecount();
//     this.userline();
//     this.fetchUserList();
//     this.applicantList();
//     this.jobopeninglist();
//     this.interview_scheduled_list();
//     this.Hr_list();
//     this.Interviewer_list();
//     this.Personality_score();
//   }

//   Personality_score = () => {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/personality_list/")
//       .then((response) => {
//         const Personality_score = response.data;
//         const filteredData = Personality_score.filter((item) => {
//           return (
//             item.max_personality.includes("neuroticism") ||
//             item.max_personality.includes("conscientiousness") ||
//             item.max_personality.includes("openness") ||
//             item.max_personality.includes("extraversion") ||
//             item.max_personality.includes("agreeableness")
//           );
//         });
//         this.setState({ Personality_score, filteredData });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

//   Interviewer_list() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/Interviewer_list/")
//       .then((response) => {
//         const Interviewer_list = response.data;
//         this.setState({ Interviewer_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   Hr_list() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/HR_list/")
//       .then((response) => {
//         const Hr_list = response.data;
//         this.setState({ Hr_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   interview_scheduled_list() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/get_interview_list/")
//       .then((response) => {
//         const interview_scheduled_list = response.data;
//         this.setState({ interview_scheduled_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   fetchUserList() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/list_users/")
//       .then((response) => {
//         const user_list = response.data;
//         this.setState({ user_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   applicantList() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/get_applicant_names/")
//       .then((response) => {
//         const applicant_list = response.data;
//         this.setState({ applicant_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   jobopeninglist() {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/job_opening_list/")
//       .then((response) => {
//         const jobopening_list = response.data;
//         this.setState({ jobopening_list });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }
//   userline() {
//     // Fetch monthly user counts from backend API
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/get_user_count_data/")
//       .then((response) => {
//         const monthlyUserCounts = response.data.user_counts;
//         this.setState({ monthlyUserCounts });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   getMonthName = (month) => {
//     const monthNames = [
//       "January",
//       "February",
//       "March",
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//     ];
//     return monthNames[month - 1];
//   };

//   fetchJobApplicationStatusCounts() {
//     this.setState({ isLoading: true });
//     fetch("https://raasbackend.vetrinahealthcare.com/job_application_status_counts/")
//       .then((response) => response.json())
//       .then((data) => {
//         const {
//           Applied,
//           under_review,
//           interview_scheduled,
//           selected,
//           rejected,
//         } = data.status_counts;
//         this.setState({
//           appliedCount: Applied || 0,
//           underReviewCount: under_review || 0,
//           interviewScheduledCount: interview_scheduled || 0,
//           selectedCount: selected || 0,
//           rejectedCount: rejected || 0,
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching job application status counts:", error);
//         this.setState({ isLoading: false });
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchrolecount() {
//     fetch("https://raasbackend.vetrinahealthcare.com/get_role_count/")
//       .then((response) => response.json())
//       .then((data) => {
//         const { Candidate, Interviewer, HR, Admin } = data.status_counts;
//         this.setState({
//           candidatecount: Candidate,
//           interviewercount: Interviewer || 0,
//           hrcount: HR || 0,
//           admincount: Admin || 0,
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching job application status counts:", error);
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchTotalJobOpenings() {
//     this.setState({ isLoading: true });
//     fetch("https://raasbackend.vetrinahealthcare.com/total_job_openings/")
//       .then((response) => response.json())
//       .then((data) => {
//         this.setState({ totalJobOpenings: data.total_job_openings });
//       })
//       .catch((error) => {
//         console.error("Error fetching total job openings:", error);
//         this.setState({ isLoading: false });
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchTotalApplicants() {
//     fetch("https://raasbackend.vetrinahealthcare.com/total_applicants/")
//       .then((response) => response.json())
//       .then((data) => {
//         this.setState({ totalApplicants: data.total_applicants });
//       })
//       .catch((error) => {
//         console.error("Error fetching total applicants:", error);
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchTotalInterviews() {
//     this.setState({ isLoading: true });
//     fetch("https://raasbackend.vetrinahealthcare.com/interviews/")
//       .then((response) => response.json())
//       .then((data) => {
//         this.setState({ totalInterviews: data.length });
//       })
//       .catch((error) => {
//         console.error("Error fetching total interviews:", error);
//         this.setState({ isLoading: false });
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchTotalUsers() {
//     this.setState({ isLoading: true });
//     fetch("https://raasbackend.vetrinahealthcare.com/total_users/")
//       .then((response) => response.json())
//       .then((data) => {
//         this.setState({ totalusers: data.total_users });
//       })
//       .catch((error) => {
//         console.error("Error fetching total Users:", error);
//         this.setState({ isLoading: false });
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }

//   fetchTotalAccountStatus() {
//     this.setState({ isLoading: true });
//     fetch("https://raasbackend.vetrinahealthcare.com/total_account_status/")
//       .then((response) => response.json())
//       .then((data) => {
//         const { active_users, inactive_users } = data;
//         this.setState({
//           activeUsersCount: active_users,
//           inactiveUsersCount: inactive_users,
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching total Users:", error);
//         this.setState({ isLoading: false });
//       })
//       .finally(() => {
//         this.setState({ isLoading: false });
//       });
//   }
//   filterByDate = () => {
//     const { user_list, startDate, endDate } = this.state;
//     return user_list.filter((user) => {
//       const createdAt = moment(user.created_at, "DD/MM/YYYY");
//       if (startDate && endDate) {
//         return createdAt.isBetween(startDate, endDate, null, "[]");
//       } else if (startDate) {
//         return createdAt.isSameOrAfter(startDate, "day");
//       } else if (endDate) {
//         return createdAt.isSameOrBefore(endDate, "day");
//       }
//       return true;
//     });
//   };
//   handleStartDateChange = (date) => {
//     this.setState({ startDate: date });
//   };

//   handleEndDateChange = (date) => {
//     this.setState({ endDate: date });
//   };

//   // Function to filter users based on name
//   filterByName = () => {
//     const { user_list, filterName } = this.state;
//     return user_list.filter((user) =>
//       user.name.toLowerCase().includes(filterName.toLowerCase())
//     );
//   };

//   // Function to handle change in date filter input
//   handleDateChange = (e) => {
//     this.setState({ filterDate: e.target.value });
//   };

//   // Function to handle change in name filter input
//   handleNameChange = (e) => {
//     this.setState({ filterName: e.target.value });
//   };

//   handleButtonClick = () => {
//     this.setState({ showInput: true });
//   };

//   // Function to toggle visibility of date input
//   toggleDateInput = () => {
//     this.setState((prevState) => ({
//       showDateInput: !prevState.showDateInput,
//     }));
//   };

//   // Function to toggle visibility of name input
//   toggleNameInput = () => {
//     this.setState((prevState) => ({
//       showNameInput: !prevState.showNameInput,
//     }));
//   };

//   filterByDate1 = () => {
//     const { interview_scheduled_list, filterDate1 } = this.state;
//     return interview_scheduled_list.filter((interview) =>
//       interview.date.includes(filterDate1)
//     );
//   };

//   handleDateChange1 = (e) => {
//     this.setState({ filterDate1: e.target.value });
//   };

//   toggleDateInput1 = () => {
//     this.setState((prevState) => ({
//       showDateInput1: !prevState.showDateInput1,
//     }));
//   };

//   filterByDate2 = () => {
//     const { jobopening_list, startDate2, endDate2 } = this.state;
//     return jobopening_list.filter((user) => {
//       const createdAt = moment(user.created_at, "DD/MM/YYYY");
//       if (startDate2 && endDate2) {
//         return createdAt.isBetween(startDate2, endDate2, null, "[]");
//       } else if (startDate2) {
//         return createdAt.isSameOrAfter(startDate2, "day");
//       } else if (endDate2) {
//         return createdAt.isSameOrBefore(endDate2, "day");
//       }
//       return true;
//     });
//   };
//   handleStartDateChange2 = (date) => {
//     this.setState({ startDate2: date });
//   };

//   handleEndDateChange2 = (date) => {
//     this.setState({ endDate2: date });
//   };

//   filterByName2 = () => {
//     const { jobopening_list, filterName2 } = this.state;
//     return jobopening_list.filter((user) =>
//       user.jobtitle.toLowerCase().includes(filterName2.toLowerCase())
//     );
//   };

//   handleDateChange2 = (e) => {
//     this.setState({ filterDate2: e.target.value });
//   };

//   // Function to handle change in name filter input
//   handleNameChange2 = (e) => {
//     this.setState({ filterName2: e.target.value });
//   };

//   toggleDateInput2 = () => {
//     this.setState((prevState) => ({
//       showDateInput2: !prevState.showDateInput2,
//     }));
//   };

//   toggleNameInput2 = () => {
//     this.setState((prevState) => ({
//       showNameInput2: !prevState.showNameInput2,
//     }));
//   };

//   handleTraitChange = (event) => {
//     this.selectedTrait = event.target.value;
//     const filteredData = this.state.Personality_score.filter((item) => {
//       return item.max_personality.includes(this.selectedTrait);
//     });
//     this.setState({ filteredData });
//   };

//   // componentDidMount() {
//   //   // Fetch interview data and set state
//   //   this.interview_scheduled_list();
//   // }
//   loadPage(pageNumber) {
//     const { perPage } = this.state;
//     const offset = pageNumber * perPage;
//     const filteredData = this.state.user_list.slice(offset, offset + perPage);
//     console.log("Filtered data for page", pageNumber, ":", filteredData);
//     this.setState({ currentPage: pageNumber, filteredUsers: filteredData });
//   }

//   handlePageClick = (data) => {
//     const selectedPage = data.selected;
//     this.loadPage(selectedPage);
//   };

//   handleUserPageChange = (page) => {
//     this.setState({ userCurrentPage: page });
//   };

//   handleInterviewPageChange = (page) => {
//     this.setState({ interviewCurrentPage: page });
//   };

//   handleJobOpeningPageChange = (page) => {
//     this.setState({ jobOpeningCurrentPage: page });
//   };

//   // Function to handle the deletion of a job opening
//   deleteJobOpening(jobId) {
//     axios
//       .delete(`https://raasbackend.vetrinahealthcare.com/job_opening/${jobId}/`)
//       .then((response) => {
//         // Update the state to remove the deleted job
//         this.setState((prevState) => ({
//           jobopening_list: prevState.jobopening_list.filter(
//             (job) => job.job_id !== jobId
//           ),
//         }));
//         // Provide feedback to the user
//         alert("Job opening deleted successfully!");
//         console.log("Job opening deleted:", response.data);
//       })
//       .catch((error) => {
//         // Handle any errors here
//         console.error("Error deleting job opening:", error);
//         // Provide error feedback to the user
//         alert("Failed to delete job opening. Please try again.");
//       });
//   }

//   render() {
//     const { isLoading } = this.state;
//     const { filterDate, filterName, showDateInput, showNameInput, user_list } =
//       this.state;
//     const { filterDate1, showDateInput1 } = this.state;
//     const { filterDate2, showDateInput2, filterName2, showNameInput2 } =
//       this.state;
//     const { endDate, startDate } = this.state;
//     const { endDate2, startDate2 } = this.state;
//     const filteredJobOpenings = this.filterByDate2().filter((user) =>
//       this.filterByName2().includes(user)
//     );
//     const filteredInterviews = this.filterByDate1();
//     // Apply filters and get filtered users
//     const filteredUsers = this.filterByDate().filter((user) =>
//       this.filterByName().includes(user)
//     );
//     const { userCurrentPage, userItemsPerPage } = this.state;
//     const { interviewCurrentPage, interviewItemsPerPage } = this.state;
//     const { jobOpeningCurrentPage, jobOpeningItemsPerPage } = this.state;

//     const userIndexOfLastItem = userCurrentPage * userItemsPerPage;
//     const userIndexOfFirstItem = userIndexOfLastItem - userItemsPerPage;
//     const currentUserItems = filteredUsers.slice(
//       userIndexOfFirstItem,
//       userIndexOfLastItem
//     );

//     const interviewIndexOfLastItem =
//       interviewCurrentPage * interviewItemsPerPage;
//     const interviewIndexOfFirstItem =
//       interviewIndexOfLastItem - interviewItemsPerPage;
//     const currentInterviewItems = filteredInterviews.slice(
//       interviewIndexOfFirstItem,
//       interviewIndexOfLastItem
//     );

//     const jobOpeningIndexOfLastItem =
//       jobOpeningCurrentPage * jobOpeningItemsPerPage;
//     const jobOpeningIndexOfFirstItem =
//       jobOpeningIndexOfLastItem - jobOpeningItemsPerPage;
//     const currentJobOpeningItems = filteredJobOpenings.slice(
//       jobOpeningIndexOfFirstItem,
//       jobOpeningIndexOfLastItem
//     );

//     const {
//       totalusers,
//       totalApplicants,
//       totalInterviews,
//       totalJobOpenings,
//       appliedCount,
//       underReviewCount,
//       interviewScheduledCount,
//       selectedCount,
//       rejectedCount,
//       hrcount,
//       candidatecount,
//       interviewercount,
//       admincount,
//       activeUsersCount,
//       inactiveUsersCount,
//     } = this.state;
//     const pieChartData = [
//       { name: "Under Review", value: underReviewCount },
//       { name: "Selected", value: selectedCount },
//       { name: "Rejected", value: rejectedCount },
//       { name: "Interview Scheduled", value: interviewScheduledCount },
//       { name: "Applied", value: appliedCount },
//     ];

//     const COLORS = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];
//     const options = {
//       animationEnabled: true,
//       // exportEnabled: true,
//       backgroundColor: "#ffffff",
//       data: [
//         {
//           // color:  COLORS,
//           type: "doughnut",
//           showInLegend: true,
//           // indexLabel: "{name}: {y}",
//           // yValueFormatString: "#,###",
//           dataPoints: [
//             { color: "#9966FF", name: "Applied", y: appliedCount },
//             { color: "#3399CC", name: "Selected", y: selectedCount },
//             { color: "#FFCC66", name: "Rejected", y: rejectedCount },
//             { color: "#ff6384", name: "Under Review", y: underReviewCount },
//             {
//               color: "#4bc0c0",
//               name: "Interview Scheduled",
//               y: interviewScheduledCount,
//             },
//           ],
//         },
//       ],
//     };

//     const { monthlyUserCounts } = this.state;
//     // Create an array to hold user counts for each month (initialize with zeros)
//     let monthCounts = Array.from({ length: 12 }, () => 0);

//     // Populate monthCounts with actual user counts where available
//     monthlyUserCounts.forEach((entry) => {
//       const monthIndex = entry.month - 1; // Convert month number to zero-based index
//       monthCounts[monthIndex] = entry.count;
//     });
//     // Function to get month name from month number
//     const getMonthName = (month) => {
//       const months = [
//         "January",
//         "February",
//         "March",
//         "April",
//         "May",
//         "June",
//         "July",
//         "August",
//         "September",
//         "October",
//         "November",
//         "December",
//       ];
//       return months[month];
//     };

//     const dataPoints = monthCounts.map((count, index) => ({
//       label: getMonthName(index),
//       y: count,
//     }));

//     const data = {
//       animationEnabled: true,
//       interactivityEnabled: true,
//       responsive: true,
//       height: 300,
//       backgroundColor: "#ffffff",
//       // backgroundColor: "rgb(0,0,0,0.0)",      //opacity background
//       axisX: {
//         title: "Months",
//         valueFormatString: "MMM",
//         interval: 1,
//       },
//       axisY: {
//         title: "User Count",
//       },
//       data: [
//         {
//           lineColor: " #321fdb",
//           type: "spline",
//           dataPoints: dataPoints,
//         },
//       ],
//       animation: {
//         duration: 2000,
//       },
//     };

//     const columns = [
//       {
//         name: (
//           <h6>
//             <b>Name</b>
//           </h6>
//         ),
//         selector: "name",
//         format: (row) => row.name,
//         // sortable: true,
//       },
//       {
//         name: (
//           <h6>
//             <b>Date</b>
//           </h6>
//         ),
//         selector: "created_at",
//         format: (row) => row.created_at.slice(0, 10),
//         // sortable: true,
//       },
//       {
//         name: (
//           <h6>
//             <b>Profile Completed</b>
//           </h6>
//         ),
//         selector: "status",
//         format: (row) => row.status,
//         // sortable: true,
//       },
//     ];

//     const columns_job = [
//       {
//         name: (
//           <h6>
//             <b>Job ID</b>
//           </h6>
//         ),
//         selector: "job_id",
//         format: (row) => row.job_id,
//       },
//       {
//         name: (
//           <h6>
//             <b>Date</b>
//           </h6>
//         ),
//         selector: "created_at",
//         format: (row) => row.created_at.slice(0, 10),
//       },
//       {
//         name: (
//           <h6>
//             <b>Job Title</b>
//           </h6>
//         ),
//         selector: "jobtitle",
//         format: (row) => row.jobtitle,
//       },
//       {
//         name: (
//           <h6>
//             <b>Action</b>
//           </h6>
//         ),
//         cell: (row) => (
//           <button
//             className="btn btn-danger"
//             onClick={() => this.deleteJobOpening(row.job_id)}
//           >
//             <i className="fa-solid fa-trash" />
//           </button>
//         ),
//         ignoreRowClick: true,
//         allowOverflow: true,
//         button: true,
//       },
//     ];

//     const columns_personality = [
//       {
//         name: (
//           <h6>
//             <b>Applicant Name</b>
//           </h6>
//         ),
//         selector: "name",
//         format: (item) => item.name,
//         // sortable: true,
//       },
//       {
//         name: (
//           <h6>
//             <b>Personality Test Result</b>
//           </h6>
//         ),
//         selector: "created_at",
//         format: (item) => item.max_personality.join(", "),
//         // sortable: true,
//       },
//     ];

//     const paginatedUsers = currentUserItems.slice(
//       (userCurrentPage - 1) * userItemsPerPage,
//       userCurrentPage * userItemsPerPage
//     );
//     return (
//       <>
//         {/* <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             minHeight: "50vh",
//           }}
//         > */}
//         <DashNavbar />
//         <div className="wrapper">
//           <Sidebar />
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               // marginLeft: "2rem",
//               minWidth: 0,
//             }}
//             className=" main  "
//           >
//             <div
//             // style={{
//             //   display: "flex",
//             //   flexDirection: "row",
//             //   flexWrap: "wrap",
//             // }}
//             >
//               <div
//                 className="mt-3 "
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">Total Users</h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <FiUsers style={{ color: "#ffffff", fontSize: "2em" }} />
//                   </div>
//                   {/* <p className="card-text score display-5">{totalusers}</p> */}
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       totalusers
//                     )}
//                   </p>
//                   {/* <UserLineChart className='linechart' />                    */}
//                 </div>

//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">Total Applicants</h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <ImUserTie style={{ color: "#ffffff", fontSize: "2em" }} />
//                   </div>
//                   {/* <p className="card-text score display-5">{totalApplicants}</p> */}
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       totalApplicants
//                     )}
//                   </p>
//                 </div>

//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">
//                     Total Interviews Scheduled
//                   </h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <AiOutlineSchedule
//                       style={{ color: "#ffffff", fontSize: "2em" }}
//                     />
//                   </div>
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       totalInterviews
//                     )}
//                   </p>
//                 </div>
//               </div>

//               <div
//                 className="mt-3"
//                 style={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   flexDirection: "row",
//                   //   marginRight: "3rem",
//                   // marginTop: "4rem",
//                 }}
//               >
//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">Total Job Openings</h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <MdWork style={{ color: "#ffffff", fontSize: "2em" }} />
//                   </div>
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       totalJobOpenings
//                     )}
//                   </p>
//                 </div>
//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">Total Interviewers</h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <FaUserTie style={{ color: "#ffffff", fontSize: "2em" }} />
//                   </div>
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       totalInterviews
//                     )}
//                   </p>
//                 </div>

//                 <div className="card-body admin ab admincardhover mb-1">
//                   <h5 className="card-title headline">Total Candidates</h5>
//                   <div
//                     style={{ backgroundColor: "#0000", marginLeft: "180px" }}
//                   >
//                     <HiMiniUserGroup
//                       style={{ color: "#ffffff", fontSize: "2em" }}
//                     />
//                   </div>
//                   <p className="card-text score display-5">
//                     {this.state.isLoading ? (
//                       <div className="loader-container">
//                         {/* Replace this with your preferred loader component */}
//                         <ClipLoader color="#ffffff" size={30} />
//                       </div>
//                     ) : (
//                       candidatecount
//                     )}
//                   </p>
//                 </div>
//               </div>

//               <div className=" linechart mt-3 w-100">
//                 <CanvasJSChart options={data} animationEnabled={true} />
//               </div>
//             </div>
//             <div className="container-fluid">
//               <div className="row mt-2 ">
//                 <div className="col-lg-6">
//                   <div className="container-fluid">
//                     <div className="row mt-3">
//                       <div className="col">
//                         <div className="card-body1 candidate applied admincardhover">
//                           <h5 className="card-title headline1">Applied</h5>
//                           {/* <p className="card-text score display-5">
//                             {appliedCount}
//                           </p> */}
//                           <p className="card-text score display-5">
//                             {this.state.isLoading ? (
//                               <div className="loader-container">
//                                 {/* Replace this with your preferred loader component */}
//                                 <ClipLoader color="#ffffff" size={30} />
//                               </div>
//                             ) : (
//                               appliedCount
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col">
//                         <div className="card-body1 candidate review admincardhover">
//                           <h5 className="card-title headline1">Under Review</h5>
//                           <p className="card-text score display-5">
//                             {this.state.isLoading ? (
//                               <div className="loader-container">
//                                 {/* Replace this with your preferred loader component */}
//                                 <ClipLoader color="#ffffff" size={30} />
//                               </div>
//                             ) : (
//                               underReviewCount
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col">
//                         <div className="card-body1 candidate interview admincardhover">
//                           <h5 className="card-title headline1">
//                             Interview Scheduled
//                           </h5>
//                           <p className="card-text score display-5">
//                             {this.state.isLoading ? (
//                               <div className="loader-container">
//                                 {/* Replace this with your preferred loader component */}
//                                 <ClipLoader color="#ffffff" size={30} />
//                               </div>
//                             ) : (
//                               interviewScheduledCount
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="row mt-3">
//                       <div className="col">
//                         <div className="card-body1 candidate selected admincardhover">
//                           <h5 className="card-title headline1">Selected</h5>
//                           <p className="card-text score display-5">
//                             {this.state.isLoading ? (
//                               <div className="loader-container">
//                                 {/* Replace this with your preferred loader component */}
//                                 <ClipLoader color="#ffffff" size={30} />
//                               </div>
//                             ) : (
//                               selectedCount
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col">
//                         <div className="card-body1 candidate rejected admincardhover">
//                           <h5 className="card-title headline1">Rejected</h5>
//                           <p className="card-text score display-5">
//                             {this.state.isLoading ? (
//                               <div className="loader-container">
//                                 {/* Replace this with your preferred loader component */}
//                                 <ClipLoader color="#ffffff" size={30} />
//                               </div>
//                             ) : (
//                               rejectedCount
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-6">
//                   <div className="container-fluid m-3">
//                     <CanvasJSChart options={options} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="container-fluid">
//               <div className="row mt-2">
//                 <div className="d-flex flex-md-row  flex-column justify-content-between align-items-center w-100">
//                   <h2>Candidates List</h2>
//                   {/* <div className='col-4 d-flex align-items-center justify-content-end'> */}
//                   <div
//                     className="form-group"
//                     style={{ backgroundColor: "transparent" }}
//                   >
//                     <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-3">
//                       {/* Start Date */}
//                     <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <DatePicker
//                           selected={startDate}
//                           onChange={this.handleStartDateChange}
//                           selectsStart
//                           startDate={startDate}
//                           endDate={endDate}
//                           placeholderText="Start Date"
//                           className="form-control startdate"
//                           dateFormat="dd-MM-yyyy"
//                         />

//                       </div>
//                     </div>

//                     {/* End Date */}
//                     <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <DatePicker
//                           selected={endDate}
//                           onChange={this.handleEndDateChange}
//                           selectsEnd
//                           startDate={startDate}
//                           endDate={endDate}
//                           minDate={startDate}
//                           placeholderText="End Date"
//                           className="form-control enddate"
//                           dateFormat="dd-MM-yyyy"
//                         />

//                       </div>
//                     </div>
//                                       {/* Search Field */}
//                                       <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <input
//                           type="search"
//                           className="form-control enddate"
//                           placeholder="Enter Candidate Name"
//                           value={filterName}
//                           onChange={this.handleNameChange}
//                         />

//                       </div>
//                     </div>
//                   </div>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <DataTable
//                   columns={columns}
//                   data={filteredUsers}
//                   pagination
//                   paginationPerPage={userItemsPerPage}
//                   paginationRowsPerPageOptions={[3, 5, 10, 15]} // Optional: Customize rows per page options
//                   paginationComponentOptions={{
//                     rowsPerPageText: "Rows per page:", // Customize text for rows per page label
//                   }}
//                   paginationTotalRows={filteredUsers.length}
//                   onChangePage={this.handleUserPageChange}
//                 />
//               </div>

//               <div className="row mt-5">
//                 {/* Main container for header and form controls */}
//                 <div className="d-flex flex-md-row flex-column justify-content-between align-items-center w-100">
//                   {/* Title */}
//                   <h2 className="mb-0">Job Opening List</h2>

//                   {/* Form controls for Start Date, End Date, and Search Field */}
//                   <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-10">
//                     {/* Start Date */}
//                     <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <DatePicker
//                           selected={startDate2}
//                           onChange={this.handleStartDateChange2}
//                           selectsStart
//                           startDate={startDate2}
//                           endDate={endDate2}
//                           placeholderText="Start Date"
//                           className="form-control startdate"
//                           dateFormat="dd-MM-yyyy"

//                         />

//                       </div>
//                     </div>

//                     {/* End Date */}
//                     <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <DatePicker
//                           selected={endDate2}
//                           onChange={this.handleEndDateChange2}
//                           selectsEnd
//                           startDate={startDate2}
//                           endDate={endDate2}
//                           minDate={startDate2}
//                           placeholderText="End Date"
//                           className="form-control enddate"
//                           dateFormat="dd-MM-yyyy"
//                         />

//                       </div>
//                     </div>

//                     {/* Search Field */}
//                     <div className="form-group mb-3 me-md-2">
//                       <div className="input-group">
//                         <input
//                           type="search"
//                           className="form-control enddate"
//                           placeholder="Enter Candidate Name"
//                           value={filterName2}
//                           onChange={this.handleNameChange2}
//                         />

//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <DataTable
//                   columns={columns_job}
//                   data={filteredJobOpenings}
//                   pagination
//                   paginationPerPage={userItemsPerPage}
//                   paginationRowsPerPageOptions={[3, 5, 10, 15]} // Optional: Customize rows per page options
//                   paginationComponentOptions={{
//                     rowsPerPageText: "Rows per page:", // Customize text for rows per page label
//                   }}
//                   paginationTotalRows={filteredJobOpenings.length}
//                   onChangePage={this.handleUserPageChange}
//                 />
//               </div>
//               <div className="row mt-2">
//                 <div className="d-flex flex-md-row  flex-column justify-content-between align-items-center">
//                   <h2>Personality Test</h2>
//                   <div
//                     className="form-group"
//                     style={{ backgroundColor: "transparent" }}
//                   >
//                     <div className="form-group  d-flex">
//                       <select
//                         onChange={this.handleTraitChange}
//                         value={this.selectedTrait}
//                         style={{
//                           width: "200px",
//                           borderRadius: "5px",
//                           padding: "5px",
//                           backgroundColor: "white",
//                           color: "#606060",
//                           border: "1px solid #C0C0C0",
//                           boxshadow: "rgba(3, 102, 214, 0.3) 0px 0px 0px 3px",
//                         }}
//                       >
//                         <option value="">Choose Personality</option>
//                         {this.traitOptions.map((option, index) => (
//                           <option key={index} value={option.value}>
//                             {option.label}
//                           </option>
//                         ))}
//                       </select>
//                       {/* <Dropdown
//                         disabled={false} // Set to true if you want the dropdown to be disabled
//                         onChange={this.handleTraitChange}
//                         value={this.selectedTrait} // Set the default selected option
//                         options={[
//                           { value: "", label: 'Select a trait' },
//                             this.traitOptions.map((option, index) => (
//                               <option key={index} value={option.value}>{option.label}</option>
//                             ))
//                         ]}
//                         placeholder="Select an option" // Placeholder text for the dropdown
//                       /> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <DataTable
//                   columns={columns_personality}
//                   data={this.state.filteredData}
//                   pagination
//                   paginationPerPage={userItemsPerPage}
//                   paginationRowsPerPageOptions={[3, 5, 10, 15]} // Optional: Customize rows per page options
//                   paginationComponentOptions={{
//                     rowsPerPageText: "Rows per page:", // Customize text for rows per page label
//                   }}
//                   paginationTotalRows={columns_personality.length}
//                   onChangePage={this.handleUserPageChange}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* </div> */}
//       </>
//     );
//   }
// }

// export default HRDashboard;
import axios from "axios";
import React, { Component, useState, useEffect } from "react";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
} from "chart.js";
import CanvasJSReact from "@canvasjs/react-charts";
import { FiUsers } from "react-icons/fi";
import { ImUserTie } from "react-icons/im";
import { AiOutlineSchedule } from "react-icons/ai";
import { MdWork } from "react-icons/md";
import { HiMiniUserGroup } from "react-icons/hi2";
import { FaUserCheck, FaUserTie, FaHardHat, FaBriefcase, FaEnvelope, FaFileContract } from "react-icons/fa";
import { FaChalkboardUser, FaUserXmark } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ClipLoader } from "react-spinners";

ChartJS.register(LineElement, PointElement, LinearScale, Title, CategoryScale);
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const UserLineChart = () => {
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://raasbackend.vetrinahealthcare.com/student"
        );
        const data = response.data;

        const groupedData = data.reduce((acc, curr) => {
          const date = curr.created_at.split("T")[0];
          if (acc[date]) {
            acc[date].count += 1;
          } else {
            acc[date] = { date, count: 1 };
          }
          return acc;
        }, {});

        const chartData = Object.values(groupedData);
        setUserData(chartData);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  const chartData = {
    labels: userData.map((data) => data.date),
    datasets: [
      {
        label: "Number of Users",
        data: userData.map((data) => data.count),
        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgba(0, 0, 0, 0)",
        borderWidth: 2,
        pointBackgroundColor: "rgba(75, 192, 192, 1)",
        pointBorderColor: "rgba(75, 192, 192, 1)",
        pointHoverBackgroundColor: "rgba(75, 192, 192, 1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        tension: 0.4,
      },
    ],
  };

  return (
    <div>
      <Line
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "Number of Users Over Time",
              font: { size: 25 },
            },
            tooltip: {
              mode: "index",
              intersect: false,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              titleFont: { size: 16 },
              bodyFont: { size: 14 },
            },
          },
          scales: {
            x: {
              grid: { display: true, color: "rgba(0, 0, 0, 0.1)" },
              ticks: { font: { size: 14 } },
            },
            y: {
              grid: { display: true, color: "rgba(0, 0, 0, 0.1)" },
              ticks: { font: { size: 14 } },
            },
          },
          animation: { duration: 1500 },
        }}
      />
    </div>
  );
};

class HRDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDate: "",
      filterName: "",
      totalusers: 0,
      activeUsersCount: 0,
      inactiveUsersCount: 0,
      totalApplicants: 0,
      totalInterviews: 0,
      totalJobOpenings: 0,
      totalTechnicalConsultants: 0,
      totalBusinessOpportunities: 0,
      appliedCount: 0,
      underReviewCount: 0,
      interviewScheduledCount: 0,
      selectedCount: 0,
      rejectedCount: 0,
      interviewercount: 0,
      hrcount: 0,
      candidatecount: 0,
      admincount: 0,
      monthlyUserCounts: [],
      user_list: [],
      applicant_list: [],
      jobopening_list: [],
      interview_scheduled_list: [],
      Hr_list: [],
      Interviewer_list: [],
      date: [],
      showDateInput: false,
      showNameInput: false,
      filterDate1: "",
      showDateInput1: false,
      filterDate2: "",
      filterName2: "",
      showDateInput2: false,
      showNameInput2: false,
      pageCount: 0,
      userCurrentPage: 1,
      userItemsPerPage: 3,
      interviewCurrentPage: 1,
      interviewItemsPerPage: 3,
      jobOpeningCurrentPage: 1,
      jobOpeningItemsPerPage: 3,
      startDate: null,
      endDate: null,
      startDate2: null,
      endDate2: null,
      Personality_score: [],
      isLoading: true,
      // New states for letter details
      letterSummary: {
        total_letters: 0,
        offer_letters_count: 0,
        appointment_letters_count: 0,
        total_sent: 0,
        total_not_sent: 0
      },
      offerLettersData: {
        total: 0,
        sent: 0,
        not_sent: 0
      },
      appointmentLettersData: {
        total: 0,
        sent: 0,
        not_sent: 0
      }
    };
    this.traitOptions = [
      { value: "neuroticism", label: "Neuroticism" },
      { value: "conscientiousness", label: "Conscientiousness" },
      { value: "openness", label: "Openness" },
      { value: "extraversion", label: "Extraversion" },
      { value: "agreeableness", label: "Agreeableness" },
    ];
    this.selectedTrait = "";
  }
  
  componentDidMount() {
    this.fetchTotalApplicants();
    this.fetchTotalInterviews();
    this.fetchTotalJobOpenings();
    this.fetchJobApplicationStatusCounts();
    this.fetchTotalUsers();
    this.fetchTotalAccountStatus();
    this.fetchrolecount();
    this.userline();
    this.fetchUserList();
    this.applicantList();
    this.jobopeninglist();
    this.interview_scheduled_list();
    this.Hr_list();
    this.Interviewer_list();
    this.Personality_score();
    this.fetchJobPostingStatus();
    this.fetchLetterDetails();
  }

  fetchLetterDetails = () => {
    this.setState({ isLoading: true });
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_letter_details/")
      .then((response) => {
        const data = response.data;
        this.setState({
          letterSummary: data.summary,
          offerLettersData: data.offer_letters,
          appointmentLettersData: data.appointment_letters,
          isLoading: false
        });
      })
      .catch((error) => {
        console.error("Error fetching letter details:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchJobPostingStatus = () => {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/JobPostingresultByStatus/")
      .then((response) => {
        this.setState({
          totalTechnicalConsultants:
            response.data.technical_consultants.length,
          totalBusinessOpportunities:
            response.data.business_opportunities.length,
        });
      })
      .catch((error) => {
        console.error("Error fetching job posting status:", error);
      });
  };

  Personality_score = () => {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/personality_list/")
      .then((response) => {
        const Personality_score = response.data;
        const filteredData = Personality_score.filter((item) => {
          return (
            item.max_personality.includes("neuroticism") ||
            item.max_personality.includes("conscientiousness") ||
            item.max_personality.includes("openness") ||
            item.max_personality.includes("extraversion") ||
            item.max_personality.includes("agreeableness")
          );
        });
        this.setState({ Personality_score, filteredData });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  Interviewer_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/Interviewer_list/")
      .then((response) => {
        const Interviewer_list = response.data;
        this.setState({ Interviewer_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  Hr_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/HR_list/")
      .then((response) => {
        const Hr_list = response.data;
        this.setState({ Hr_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  interview_scheduled_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_interview_list/")
      .then((response) => {
        const interview_scheduled_list = response.data;
        this.setState({ interview_scheduled_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  fetchUserList() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/list_users/")
      .then((response) => {
        const user_list = response.data;
        this.setState({ user_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  applicantList() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_applicant_names/")
      .then((response) => {
        const applicant_list = response.data;
        this.setState({ applicant_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  jobopeninglist() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/job_opening_list/")
      .then((response) => {
        const rawJobOpenings = response.data;
        const sortedJobOpenings = [...rawJobOpenings].sort((a, b) => {
          if (a.job_id < b.job_id) return -1;
          if (a.job_id > b.job_id) return 1;
          return 0;
        });
        this.setState({ jobopening_list: sortedJobOpenings });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }
  
  userline() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_user_count_data/")
      .then((response) => {
        const monthlyUserCounts = response.data.user_counts;
        this.setState({ monthlyUserCounts });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  fetchJobApplicationStatusCounts() {
    this.setState({ isLoading: true });
    fetch(
      "https://raasbackend.vetrinahealthcare.com/job_application_status_counts/"
    )
      .then((response) => response.json())
      .then((data) => {
        const {
          Applied,
          under_review,
          interview_scheduled,
          selected,
          rejected,
        } = data.status_counts;
        this.setState({
          appliedCount: Applied || 0,
          underReviewCount: under_review || 0,
          interviewScheduledCount: interview_scheduled || 0,
          selectedCount: selected || 0,
          rejectedCount: rejected || 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching job application status counts:", error);
        this.setState({ isLoading: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchrolecount() {
    fetch("https://raasbackend.vetrinahealthcare.com/get_role_count/")
      .then((response) => response.json())
      .then((data) => {
        const { Candidate, Interviewer, HR, Admin } = data.status_counts;
        this.setState({
          candidatecount: Candidate,
          interviewercount: Interviewer || 0,
          hrcount: HR || 0,
          admincount: Admin || 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching job application status counts:", error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchTotalJobOpenings() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/total_job_openings/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalJobOpenings: data.total_job_openings });
      })
      .catch((error) => {
        console.error("Error fetching total job openings:", error);
        this.setState({ isLoading: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchTotalApplicants() {
    fetch("https://raasbackend.vetrinahealthcare.com/total_applicants/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalApplicants: data.total_applicants });
      })
      .catch((error) => {
        console.error("Error fetching total applicants:", error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchTotalInterviews() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/interviews/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalInterviews: data.length });
      })
      .catch((error) => {
        console.error("Error fetching total interviews:", error);
        this.setState({ isLoading: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchTotalUsers() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/total_users/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalusers: data.total_users });
      })
      .catch((error) => {
        console.error("Error fetching total Users:", error);
        this.setState({ isLoading: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  fetchTotalAccountStatus() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/total_account_status/")
      .then((response) => response.json())
      .then((data) => {
        const { active_users, inactive_users } = data;
        this.setState({
          activeUsersCount: active_users,
          inactiveUsersCount: inactive_users,
        });
      })
      .catch((error) => {
        console.error("Error fetching total Users:", error);
        this.setState({ isLoading: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }
  
  filterByDate = () => {
    const { user_list, startDate, endDate } = this.state;
    return user_list.filter((user) => {
      const createdAt = moment(user.created_at, "DD/MM/YYYY");
      if (startDate && endDate) {
        return createdAt.isBetween(startDate, endDate, null, "[]");
      } else if (startDate) {
        return createdAt.isSameOrAfter(startDate, "day");
      } else if (endDate) {
        return createdAt.isSameOrBefore(endDate, "day");
      }
      return true;
    });
  };
  
  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  filterByName = () => {
    const { user_list, filterName } = this.state;
    return user_list.filter((user) =>
      user.name.toLowerCase().includes(filterName.toLowerCase())
    );
  };

  handleDateChange = (e) => {
    this.setState({ filterDate: e.target.value });
  };

  handleNameChange = (e) => {
    this.setState({ filterName: e.target.value });
  };

  filterByDate1 = () => {
    const { interview_scheduled_list, filterDate1 } = this.state;
    return interview_scheduled_list.filter((interview) =>
      interview.date.includes(filterDate1)
    );
  };

  handleDateChange1 = (e) => {
    this.setState({ filterDate1: e.target.value });
  };

  filterByDate2 = () => {
    const { jobopening_list, startDate2, endDate2 } = this.state;
    return jobopening_list.filter((user) => {
      const createdAt = moment(user.created_at, "DD/MM/YYYY");
      if (startDate2 && endDate2) {
        return createdAt.isBetween(startDate2, endDate2, null, "[]");
      } else if (startDate2) {
        return createdAt.isSameOrAfter(startDate2, "day");
      } else if (endDate2) {
        return createdAt.isSameOrBefore(endDate2, "day");
      }
      return true;
    });
  };
  
  handleStartDateChange2 = (date) => {
    this.setState({ startDate2: date });
  };

  handleEndDateChange2 = (date) => {
    this.setState({ endDate2: date });
  };

  filterByName2 = () => {
    const { jobopening_list, filterName2 } = this.state;
    return jobopening_list.filter((user) =>
      user.jobtitle.toLowerCase().includes(filterName2.toLowerCase())
    );
  };

  handleDateChange2 = (e) => {
    this.setState({ filterDate2: e.target.value });
  };

  handleNameChange2 = (e) => {
    this.setState({ filterName2: e.target.value });
  };

  handleTraitChange = (event) => {
    this.selectedTrait = event.target.value;
    const filteredData = this.state.Personality_score.filter((item) => {
      return item.max_personality.includes(this.selectedTrait);
    });
    this.setState({ filteredData });
  };

  handleUserPageChange = (page) => {
    this.setState({ userCurrentPage: page });
  };

  handleInterviewPageChange = (page) => {
    this.setState({ interviewCurrentPage: page });
  };

  handleJobOpeningPageChange = (page) => {
    this.setState({ jobOpeningCurrentPage: page });
  };

  deleteJobOpening(jobId) {
    axios
      .delete(`https://raasbackend.vetrinahealthcare.com/job_opening/${jobId}/`)
      .then((response) => {
        this.setState((prevState) => ({
          jobopening_list: prevState.jobopening_list.filter(
            (job) => job.job_id !== jobId
          ),
        }));
        alert("Job opening deleted successfully!");
      })
      .catch((error) => {
        console.error("Error deleting job opening:", error);
        alert("Failed to delete job opening. Please try again.");
      });
  }

  render() {
    const {
      isLoading,
      filterDate,
      filterName,
      user_list,
      filterDate1,
      filterDate2,
      filterName2,
      endDate,
      startDate,
      endDate2,
      startDate2,
      userCurrentPage,
      userItemsPerPage,
      totalusers,
      totalApplicants,
      totalInterviews,
      totalJobOpenings,
      totalTechnicalConsultants,
      totalBusinessOpportunities,
      appliedCount,
      underReviewCount,
      interviewScheduledCount,
      selectedCount,
      rejectedCount,
      hrcount,
      candidatecount,
      interviewercount,
      admincount,
      activeUsersCount,
      inactiveUsersCount,
      monthlyUserCounts,
      letterSummary,
    } = this.state;

    const filteredJobOpenings = this.filterByDate2().filter((user) =>
      this.filterByName2().includes(user)
    );
    const filteredInterviews = this.filterByDate1();
    const filteredUsers = this.filterByDate().filter((user) =>
      this.filterByName().includes(user)
    );

    let monthCounts = Array.from({ length: 12 }, () => 0);
    monthlyUserCounts.forEach((entry) => {
      const monthIndex = entry.month - 1;
      monthCounts[monthIndex] = entry.count;
    });
    
    const getMonthName = (month) => {
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return months[month];
    };

    const dataPoints = monthCounts.map((count, index) => ({
      label: getMonthName(index),
      y: count,
    }));

    const data = {
      animationEnabled: true,
      interactivityEnabled: true,
      responsive: true,
      height: 300,
      backgroundColor: "#ffffff",
      axisX: {
        title: "Months",
        valueFormatString: "MMM",
        interval: 1,
      },
      axisY: {
        title: "User Count",
      },
      data: [
        {
          lineColor: " #321fdb",
          type: "spline",
          dataPoints: dataPoints,
        },
      ],
      animation: {
        duration: 2000,
      },
    };

    const options = {
      animationEnabled: true,
      backgroundColor: "#ffffff",
      data: [
        {
          type: "doughnut",
          showInLegend: true,
          dataPoints: [
            { color: "#9966FF", name: "Applied", y: appliedCount },
            { color: "#3399CC", name: "Selected", y: selectedCount },
            { color: "#FFCC66", name: "Rejected", y: rejectedCount },
            { color: "#ff6384", name: "Under Review", y: underReviewCount },
            {
              color: "#4bc0c0",
              name: "Interview Scheduled",
              y: interviewScheduledCount,
            },
          ],
        },
      ],
    };

    const columns = [
      {
        name: (
          <h6>
            <b>Name</b>
          </h6>
        ),
        selector: "name",
        format: (row) => row.name,
      },
      {
        name: (
          <h6>
            <b>Date</b>
          </h6>
        ),
        selector: "created_at",
        format: (row) => row.created_at.slice(0, 10),
      },
      {
        name: (
          <h6>
            <b>Profile Completed</b>
          </h6>
        ),
        selector: "status",
        format: (row) => row.status,
      },
    ];

    const columns_job = [
      {
        name: (
          <h6>
            <b>Job ID</b>
          </h6>
        ),
        selector: "job_id",
        format: (row) => row.job_id,
      },
      {
        name: (
          <h6>
            <b>Date</b>
          </h6>
        ),
        selector: "created_at",
        format: (row) => row.created_at.slice(0, 10),
      },
      {
        name: (
          <h6>
            <b>Job Title</b>
          </h6>
        ),
        selector: "jobtitle",
        format: (row) => row.jobtitle,
      },
      {
        name: (
          <h6>
            <b>Action</b>
          </h6>
        ),
        cell: (row) => (
          <button
            className="btn btn-danger"
            onClick={() => this.deleteJobOpening(row.job_id)}
          >
            <i className="fa-solid fa-trash" />
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];

    return (
      <>
        <style>
          {`
            /* Main container styles */
            .wrapper {
              display: flex;
              width: 100%;
              min-height: 100vh;
            }
            
            .main {
              flex: 1;
              padding: 20px;
              background-color: #f8f9fa;
              overflow-x: hidden;
            }
            
            /* Card container styles */
            .card-container {
              display: flex;
              flex-wrap: wrap;
              gap: 15px;
              margin-bottom: 20px;
            }
            
            /* Card styles */
            .dashboard-card {
              border-radius: 15px;
              position: relative;
              overflow: hidden;
              height: 150px;
              padding: 20px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              transition: all 0.3s ease;
              flex: 1 1 calc(20% - 12px);
              min-width: calc(20% - 12px);
              max-width: calc(20% - 12px);
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            }
            
            .dashboard-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
            }
            
            /* Admin/HR cards background */
            .admin-card {
              background: linear-gradient(to right, rgb(137, 104, 255), rgb(175, 152, 255)) !important;
            }
            
            /* Background circles for cards */
            .admin-card::before {
              content: "";
              position: absolute;
              z-index: 1;
              border-radius: 50%;
              right: -25%;
              top: -25%;
              background: linear-gradient(to right, rgb(142, 110, 255), rgb(208, 195, 255));
              width: 130px;
              height: 130px;
            }
            
            /* Candidate status cards */
            .status-card {
              border-radius: 15px;
              padding: 20px;
              height: 120px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              transition: all 0.3s ease;
            }
            
            .status-card:hover {
              transform: translateY(-3px);
              box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
            }
            
            .applied-card {
              background: linear-gradient(60deg, #4facfe 0%, #00f2fe 100%) !important;
            }
            
            .review-card {
              background: linear-gradient(60deg, #fa709a 0%, #fee140 100%) !important;
            }
            
            .interview-card {
              background: linear-gradient(60deg, #a8edea 0%, #fed6e3 100%) !important;
            }
            
            .selected-card {
              background: linear-gradient(60deg, #43e97b 0%, #38f9d7 100%) !important;
            }
            
            .rejected-card {
              background: linear-gradient(60deg, #ff5858 0%, #f09819 100%) !important;
            }
            
            /* Text styles */
            .card-headline {
              text-align: left;
              color: aliceblue;
              position: relative;
              z-index: 2;
              font-size: 1rem;
              font-weight: 600;
              margin: 0 0 10px 0;
              line-height: 1.3;
            }
            
            .interview-card .card-headline,
            .interview-card .card-score {
              color: #333 !important;
            }
            
            .card-score {
              color: aliceblue;
              position: relative;
              z-index: 2;
              font-size: 28px;
              font-weight: 700;
              margin: 0;
              line-height: 1;
            }
            
            /* Icon positioning */
            .card-icon {
              position: absolute;
              right: 20px;
              top: 20px;
              z-index: 2;
              background: none;
            }
            
            .card-icon svg {
              font-size: 2em;
              color: #ffffff;
            }
            
            .interview-card .card-icon svg {
              color: #333;
            }
            
            /* Loading container */
            .loader-container {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              height: 100%;
              position: relative;
              z-index: 2;
            }
            
            /* Data table styles */
            .data-table-container {
              background: white;
              border-radius: 10px;
              padding: 20px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              margin-top: 20px;
            }
            
            /* Form controls */
            .form-control {
              border-radius: 8px;
              border: 1px solid #ddd;
              padding: 8px 12px;
            }
            
            .input-group {
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            }
            
            /* Responsive styles */
            @media (max-width: 1200px) {
              .dashboard-card {
                flex: 1 1 calc(25% - 12px);
                min-width: calc(25% - 12px);
                max-width: calc(25% - 12px);
              }
            }
            
            @media (max-width: 992px) {
              .dashboard-card {
                flex: 1 1 calc(33.333% - 12px);
                min-width: calc(33.333% - 12px);
                max-width: calc(33.333% - 12px);
              }
              
              .card-headline {
                font-size: 0.9rem;
              }
              
              .card-score {
                font-size: 24px;
              }
            }
            
            @media (max-width: 768px) {
              .dashboard-card {
                flex: 1 1 calc(50% - 12px);
                min-width: calc(50% - 12px);
                max-width: calc(50% - 12px);
                height: 140px;
                padding: 15px;
              }
              
              .card-icon {
                right: 15px;
                top: 15px;
              }
              
              .card-icon svg {
                font-size: 1.8em;
              }
            }
            
            @media (max-width: 576px) {
              .dashboard-card {
                flex: 1 1 100%;
                min-width: 100%;
                max-width: 100%;
                height: 130px;
              }
              
              .card-headline {
                font-size: 0.85rem;
              }
              
              .card-score {
                font-size: 22px;
              }
              
              .main {
                padding: 15px;
              }
            }
            
            /* Chart container */
            .chart-container {
              background: white;
              border-radius: 10px;
              padding: 20px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              margin-top: 20px;
            }
            
            /* Section headers */
            .section-header {
              font-size: 1.5rem;
              font-weight: 600;
              color: #333;
              margin-bottom: 20px;
            }
          `}
        </style>
        
        <DashNavbar />
        <div className="wrapper">
          <Sidebar />
          <div className="main">
            {/* First Row: 5 Cards */}
            <div className="card-container">
              {/* Card 1: Users */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Users</h5>
                <div className="card-icon">
                  <FiUsers />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalusers
                  )}
                </p>
              </div>

              {/* Card 2: Applicants */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Applicants</h5>
                <div className="card-icon">
                  <ImUserTie />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalApplicants
                  )}
                </p>
              </div>

              {/* Card 3: Interviews Scheduled */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Interviews Scheduled</h5>
                <div className="card-icon">
                  <AiOutlineSchedule />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalInterviews
                  )}
                </p>
              </div>

              {/* Card 4: Job Openings */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Job Openings</h5>
                <div className="card-icon">
                  <MdWork />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalJobOpenings
                  )}
                </p>
              </div>

              {/* Card 5: Technical Consultant */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Technical Consultant</h5>
                <div className="card-icon">
                  <FaHardHat />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalTechnicalConsultants
                  )}
                </p>
              </div>
            </div>

            {/* Second Row: 5 Cards */}
            <div className="card-container">
              {/* Card 6: Business Opportunities */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Business Opportunities</h5>
                <div className="card-icon">
                  <FaBriefcase />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalBusinessOpportunities
                  )}
                </p>
              </div>

              {/* Card 7: Interviewers */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Interviewers</h5>
                <div className="card-icon">
                  <FaUserTie />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    interviewercount
                  )}
                </p>
              </div>

              {/* Card 8: Candidates */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Candidates</h5>
                <div className="card-icon">
                  <HiMiniUserGroup />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    candidatecount
                  )}
                </p>
              </div>

              {/* Card 9: Offer Letters */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Offer Letters</h5>
                <div className="card-icon">
                  <FaEnvelope />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    letterSummary.offer_letters_count
                  )}
                </p>
              </div>

              {/* Card 10: Appointment Letters */}
              <div className="dashboard-card admin-card">
                <h5 className="card-headline">Appointment Letters</h5>
                <div className="card-icon">
                  <FaFileContract />
                </div>
                <p className="card-score">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    letterSummary.appointment_letters_count
                  )}
                </p>
              </div>
            </div>

            {/* Charts Section */}
            <div className="chart-container">
              <CanvasJSChart options={data} animationEnabled={true} />
            </div>

            {/* Status Cards and Donut Chart */}
            <div className="container-fluid" style={{ marginTop: '30px' }}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="container-fluid">
                    <div className="row mt-3">
                      <div className="col" style={{ padding: '10px' }}>
                        <div className="status-card applied-card">
                          <h5 className="card-headline">Applied</h5>
                          <p className="card-score">
                            {isLoading ? (
                              <div className="loader-container">
                                <ClipLoader color="#ffffff" size={30} />
                              </div>
                            ) : (
                              appliedCount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col" style={{ padding: '10px' }}>
                        <div className="status-card review-card">
                          <h5 className="card-headline">Under Review</h5>
                          <p className="card-score">
                            {isLoading ? (
                              <div className="loader-container">
                                <ClipLoader color="#ffffff" size={30} />
                              </div>
                            ) : (
                              underReviewCount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col" style={{ padding: '10px' }}>
                        <div className="status-card interview-card">
                          <h5 className="card-headline">Interview Scheduled</h5>
                          <p className="card-score">
                            {isLoading ? (
                              <div className="loader-container">
                                <ClipLoader color="#333" size={30} />
                              </div>
                            ) : (
                              interviewScheduledCount
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col" style={{ padding: '10px' }}>
                        <div className="status-card selected-card">
                          <h5 className="card-headline">Selected</h5>
                          <p className="card-score">
                            {isLoading ? (
                              <div className="loader-container">
                                <ClipLoader color="#ffffff" size={30} />
                              </div>
                            ) : (
                              selectedCount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col" style={{ padding: '10px' }}>
                        <div className="status-card rejected-card">
                          <h5 className="card-headline">Rejected</h5>
                          <p className="card-score">
                            {isLoading ? (
                              <div className="loader-container">
                                <ClipLoader color="#ffffff" size={30} />
                              </div>
                            ) : (
                              rejectedCount
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="chart-container">
                    <CanvasJSChart options={options} />
                  </div>
                </div>
              </div>
            </div>

            {/* Candidates List */}
            <div className="data-table-container">
              <div className="row">
                <div className="d-flex flex-md-row flex-column justify-content-between align-items-center w-100">
                  <h2 className="section-header">Candidates List</h2>
                  <div className="form-group">
                    <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-3">
                      <div className="form-group mb-3 me-md-2">
                        <div className="input-group">
                          <DatePicker
                            selected={startDate}
                            onChange={this.handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Start Date"
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3 me-md-2">
                        <div className="input-group">
                          <DatePicker
                            selected={endDate}
                            onChange={this.handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="End Date"
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3 me-md-2">
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Enter Candidate Name"
                            value={filterName}
                            onChange={this.handleNameChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <DataTable
                columns={columns}
                data={filteredUsers}
                pagination
                paginationPerPage={userItemsPerPage}
                paginationRowsPerPageOptions={[3, 5, 10, 15]}
                paginationComponentOptions={{
                  rowsPerPageText: "Rows per page:",
                }}
                paginationTotalRows={filteredUsers.length}
                onChangePage={this.handleUserPageChange}
              />
            </div>

            {/* Job Opening List */}
            <div className="data-table-container" style={{ marginTop: '30px' }}>
              <div className="row">
                <div className="d-flex flex-md-row flex-column justify-content-between align-items-center w-100">
                  <h2 className="section-header">Job Opening List</h2>
                  <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-3">
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={startDate2}
                          onChange={this.handleStartDateChange2}
                          selectsStart
                          startDate={startDate2}
                          endDate={endDate2}
                          placeholderText="Start Date"
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={endDate2}
                          onChange={this.handleEndDateChange2}
                          selectsEnd
                          startDate={startDate2}
                          endDate={endDate2}
                          minDate={startDate2}
                          placeholderText="End Date"
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Enter Candidate Name"
                          value={filterName2}
                          onChange={this.handleNameChange2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <DataTable
                columns={columns_job}
                data={filteredJobOpenings}
                pagination
                paginationPerPage={userItemsPerPage}
                paginationRowsPerPageOptions={[1, 3, 5, 10, 15]}
                paginationComponentOptions={{
                  rowsPerPageText: "Rows per page:",
                }}
                paginationTotalRows={filteredJobOpenings.length}
                onChangePage={this.handleUserPageChange}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default HRDashboard;